module.exports = __webpack_public_path__ + "img/day-10.0f6445af.png";